export default global.ENV_CONFIGURATION;
